module.exports = __webpack_public_path__ + "img/code.ec75ad5d.svg";